<h1 mat-dialog-title class="text-center mb-0 fw-bold">Connect action</h1>

<mat-divider></mat-divider>

<mat-dialog-content class="mt-1">
    <!-- TABLE -->
    <div class="mat-elevation-z2">
        <div class="d-flex justify-content-around p-2 mb-4">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Filter By name</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Collect name" #input>
                <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="Type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let row" class="fw-bold">
                    <mat-icon style="width: 20%;" [svgIcon]="row.icon"></mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let row" class="text-left"> {{row.name}}</td>
            </ng-container>

            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let row">
                    <button [disabled]="isLoading" mat-raised-button color="primary" (click)="row.addCallBack()">Connect</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
        </table>
    </div>


</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex justify-content-around mt-1">
    <button [disabled]="isLoading" mat-raised-button [color]="isLoading ? 'primary' :'warn'" class="w-25" mat-dialog-close>
        <span *ngIf="!isLoading">Cancel</span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3"
            class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>